import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-top-box-3',
  templateUrl: './app-top-box3.component.html',
  styleUrls: ['./app-top-box3.component.css']
})
export class TopBox3Component implements OnInit {

  @Input() box1txt: string;
  @Input() box1value: string;
  @Input() box2txt: string;
  @Input() box2value: string;
  @Input() box3txt: string;
  @Input() box3value: string;

  constructor(
  ) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/app-top-boxes3/app-top-box3.component.ts